import gql from "graphql-tag";

export const INSERT_INTEGRATION_SETTINGS_VALUES_ARRAY = gql`
  mutation InsertIntegrationSettingsValuesArray($input: [InsertIntegrationSettingsValues]!) {
    insertIntegrationSettingsValuesArray(input: $input)
  }
`;
